import styled from "styled-components"
import * as PropTypes from "prop-types"
import Image from "next/legacy/image"
import Typography from "../../../styled/Typography"

const Service = styled.li`
  display: inline-flex;
  align-items: center;
  background: white;
  padding: 13px 10px;
  margin: 0 25px 15px 0;
  width: auto;
  max-width: 300px;
  border-radius: 14px;
  box-shadow: 0 2px 14px 0 rgba(195, 205, 224, 0.4);
`

const Text = styled(Typography)`
  margin-left: 10px;
  line-height: 16px;
`

export default function Item({ value, image, alt, text }) {
  if (!value) return null

  return (
    <Service>
      <Image alt={alt ?? text} height={32} width={32} src={`/f_svg/static/services/${image}`} />
      <Text color="skyBlue" weight="medium">
        {text}
      </Text>
    </Service>
  )
}

Item.defaultProps = {
  value: false,
  alt: null
}

Item.propTypes = {
  value: PropTypes.bool,
  image: PropTypes.string.isRequired,
  alt: PropTypes.string,
  text: PropTypes.string.isRequired
}
